import { Snackbar, IconButton, Stack, styled } from '@ltvco/refresh-lib/theme';

export const StyledSnackbar = styled(Snackbar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: 0,
  minWidth: 'auto',
}));

export const SnackbarContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  height: '80px',
  backgroundColor: theme.palette.primary.light,
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(1, 1.5),
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  width: 28,
  height: 28,
  backgroundColor: theme.palette.background.light,
  '&:hover': {
    backgroundColor: theme.palette.text.disabled,
  },
}));
